import { render, staticRenderFns } from "./MRCardInfo.vue?vue&type=template&id=2d71981a"
import script from "./MRCardInfo.vue?vue&type=script&lang=ts"
export * from "./MRCardInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports